// Single source of truth for milestone types: order (also the board's column
// order), Swedish label, and pill styling. 'potential' is deliberately first —
// it's the leads-not-yet-contacted stage that bulk-add lands candidates in.
//
// pillClassName follows the exact global `pill`/`pill-*` convention from
// spa/src/index.css (used by feedback's DataTable columns) — pill-blue/gold/purple
// are added in this app's own index.css since the global stylesheet only ships
// red/green/grey; pill-full-green (filled, an existing global exception) is reused
// as-is for the "hired" outcome, matching the outline-vs-filled convention.
// The three interview rounds share the purple family with increasing intensity, so
// "in interviews" reads as one phase rather than three unrelated stages.
export const MILESTONE_TYPES = [
  { value: 'potential',           label: 'Prospekt',         pillClassName: 'pill pill-grey' },
  { value: 'contacted',           label: 'Kontaktad',        pillClassName: 'pill pill-blue' },
  { value: 'met',                 label: 'Träffad',          pillClassName: 'pill pill-gold' },
  { value: 'interview_1',         label: 'Intervju 1',       pillClassName: 'pill pill-purple-light' },
  { value: 'interview_2',         label: 'Intervju 2',       pillClassName: 'pill pill-purple' },
  { value: 'interview_3',         label: 'Intervju 3',       pillClassName: 'pill pill-purple-deep' },
  { value: 'hired',                label: 'Anställd',        pillClassName: 'pill pill-full-green' },
  { value: 'declined',            label: 'Tackade nej',      pillClassName: 'pill pill-wide pill-red' },
  { value: 'gone_cold',           label: 'Kallnat',          pillClassName: 'pill pill-grey' },
]

const BY_VALUE = MILESTONE_TYPES.reduce((acc, m) => { acc[m.value] = m; return acc }, {})

export const getMilestone = (value) => BY_VALUE[value] || { value, label: value, pillClassName: 'pill pill-grey' }

// The interview stages, and their mapping onto recruitment.candidate_interview's
// interview_round (1/2/3). Entering one of these requires a booked slot — the milestone
// form makes the fields required and the API rejects a stage change without them.
export const INTERVIEW_MILESTONES = ['interview_1', 'interview_2', 'interview_3']
export const isInterviewMilestone = (value) => INTERVIEW_MILESTONES.includes(value)
export const roundForMilestone    = (value) => (isInterviewMilestone(value) ? INTERVIEW_MILESTONES.indexOf(value) + 1 : null)
export const milestoneForRound    = (round) => INTERVIEW_MILESTONES[Number(round) - 1] || null

// DataTable `values` map for a `type:'pill'` column — {[value]: {label, className}}
export const MILESTONE_PILL_VALUES = MILESTONE_TYPES.reduce((acc, m) => {
  acc[m.value] = { label: m.label, className: m.pillClassName }
  return acc
}, {})

// Milestones that end a candidate's active pipeline — used to visually separate
// closed outcomes from the still-in-progress board columns.
export const CLOSED_MILESTONES = new Set(['hired', 'declined', 'gone_cold'])
